import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Typography, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Library1 from "../images/img1.jpg"; // तुमची इमेज

const WelcomeHeading = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        backgroundImage: `url(${Library1})`,
        backgroundPosition: "top center", 
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: { xs: "scroll", md: "fixed" }, 
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(135deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.4) 100%)",
          zIndex: 1,
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
          py: { xs: 4, sm: 6, md: 10 },
          px: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: 4, lg: 6 },
          alignItems: "center",
        }}
      >
        {/* LEFT GLASSMORPHISM CARD */}
        <Box
          sx={{
            flex: 1.2,
            background: "rgba(255, 255, 255, 0.92)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            padding: { xs: 3, sm: 4, md: 5 },
            borderRadius: "20px",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.35)",
            border: "1px solid rgba(255, 255, 255, 0.5)",
            animation: "slideInLeft 1s ease-out forwards",
            "@keyframes slideInLeft": {
              "0%": { opacity: 0, transform: "translateX(-40px)" },
              "100%": { opacity: 1, transform: "translateX(0)" },
            },
          }}
        >
          {/* HEADING (बदल: अंडरलाईन करणारा &::after भाग काढून टाकला आहे) */}
          <Typography
            variant="h1"
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "28px", sm: "32px", md: "38px" },
              fontWeight: 700,
              color: "#5a1e1e",
              mb: 2.5,
              display: "inline-block", 
              position: "relative",
            }}
          >
            “आमच्याविषयी”
          </Typography>

          {/* HIGHLIGHT TEXT */}
          <Typography
            paragraph
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "16px", md: "17.5px" },
              lineHeight: 1.8,
              color: "#000",
              fontWeight: 500,
              textAlign: "justify",
              mb: 2.5,
            }}
          >
            <Box component="span" sx={{ color: "#5a1e1e", fontWeight: 700 }}>
              कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय
            </Box>{" "}
            हे ज्ञान, अध्ययन आणि बौद्धिक विकासाचे एक समर्पित केंद्र असून दिनांक{" "}
            <Box component="span" sx={{ color: "#5a1e1e", fontWeight: 700 }}>
              ०६ जानेवारी २००९
            </Box>{" "}
            रोजी कोडोली, ता. पन्हाळा, जि. कोल्हापूर (महाराष्ट्र) येथे स्थापना करण्यात
            आली. या ग्रंथालयाची स्थापना{" "}
            <Box component="span" sx={{ color: "#5a1e1e", fontWeight: 700 }}>
              श्री. मकरंद जगन्नाथ बुरांडे
            </Box>{" "}
            यांनी वाचनसंस्कृती, संशोधन व आजीवन शिक्षणाची आवड निर्माण करण्याच्या
            उद्देशाने केली.
          </Typography>

          {/* NORMAL TEXT PARAGRAPHS */}
          <Typography
            paragraph
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "15px", md: "16px" },
              lineHeight: 1.75,
              color: "#222",
              textAlign: "justify",
              mb: 2,
            }}
          >
            हे ग्रंथालय सर्व लागू शासकीय नियम, अटी व मानकांनुसार विकसित व
            व्यवस्थापित करण्यात आले आहे. ग्रंथालयास <b>D दर्जाची मान्यता</b> प्राप्त
            अशून शैक्षणिक व प्रशासकीय निकषांचे पालन करण्यात येते. सीएसआर मार्गदर्शक
            तत्त्वांनुसार आवश्यक नोंदी व दस्तऐवज जतन केले जातात. पारदर्शकता व
            गुणवत्तावाढीसाठी दरवर्षी नियमित वार्षिक लेखापरीक्षण केले जाते.
          </Typography>

          <Typography
            paragraph
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "15px", md: "16px" },
              lineHeight: 1.75,
              color: "#222",
              textAlign: "justify",
              mb: 2,
            }}
          >
            स्थापनेपासून आजपर्यंत हे ग्रंथालय विद्यार्थी, संशोधन व सर्वसामान्य
            वाचकांच्या शैक्षणिक गरजांसाठी सातत्याने विकसित होत आहे. पुस्तके,
            नियतकालिके, वृत्तपत्रे व डिजिटल साधनसामग्रीचा समृद्ध संग्रह येथे उपलब्ध
            मूर्ती असून शिक्षण, संशोधन व स्वअध्ययनास चालना मिळते.
          </Typography>

          <Typography
            paragraph
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "15px", md: "16px" },
              lineHeight: 1.75,
              color: "#222",
              textAlign: "justify",
              mb: 2,
            }}
          >
            ग्रंथालय हे जिज्ञासा, चिकित्सक विचारसरणी व मुक्त विचारविनिमयाला
            प्रोत्साहन देणारे केंद्र आहे. शैक्षणिक गुणवत्ता वाढवण्याबरोबरच वाचनाची
            सवय व बौद्धिक विकास घडवून आणण्याचे कार्य येथे केले जाते.
          </Typography>

          <Typography
            paragraph
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              fontSize: { xs: "15px", md: "16px" },
              lineHeight: 1.75,
              color: "#222",
              textAlign: "justify",
              mb: 3,
            }}
          >
            हे ग्रंथालय कोल्हापूर जिल्हा ग्रंथालय संघ, कोल्हापूर यासह विविध
            मान्यताप्राप्त संस्थांचे सदस्य आहे. ग्रामीण भागात ज्ञानकेंद्र व सामाजिक
            सेवाभावी संस्था म्हणून कार्य करत हे ग्रंथालय विद्यार्थी, युवक, महिला,
            शेतकरी व सर्वसामान्य नागरिकांमध्ये साक्षरता व आजीवन शिक्षणाचा प्रसार
            करते.
          </Typography>

          {/* BUTTON */}
          <Button
            variant="text"
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate("/about")}
            sx={{
              fontFamily: "'Noto Serif Devanagari', serif",
              color: "#f39c12",
              fontWeight: 700,
              fontSize: "16px",
              textTransform: "none",
              padding: 0,
              "&:hover": {
                color: "#5a1e1e",
                backgroundColor: "transparent",
                "& .MuiButton-endIcon": {
                  transform: "translateX(6px)",
                },
              },
              "& .MuiButton-endIcon": {
                transition: "transform 0.3s ease",
              },
            }}
          >
            अधिक वाचा
          </Button>
        </Box>

        {/* RIGHT SIDE MODERN SQUARE IMAGE */}
        <Box
          sx={{
            flex: 0.8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            animation: "fadeInRight 1.2s ease-out forwards",
            "@keyframes fadeInRight": {
              "0%": { opacity: 0, transform: "scale(0.95) translateY(20px)" },
              "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: { xs: "340px", sm: "400px", md: "450px" },
              aspectRatio: "4/3",
              borderRadius: "24px",
              padding: "10px",
              background: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 15px 35px rgba(0, 0, 0, 0.4)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              transition: "transform 0.4s ease, box-shadow 0.4s ease",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 25px 50px rgba(0, 0, 0, 0.5)",
                "& img": {
                  transform: "scale(1.05)",
                },
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
              }}
            >
              <Box
                component="img"
                src={Library1}
                alt="Library View"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.5s ease",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default WelcomeHeading;